import React from 'react'; 
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { Form, Select } from 'antd';
import PropTypes from "prop-types";
import {
    WrapLabel,
    LabelWrapper,
    SelectOptionWrapper,
    SelectOptionGraded,
    InputWrapperGraded,
    InputWrapper, 
    GrantAgreementDropdown,
    HideArrow,
} from "../../ContributionType/styles";
import { Rules } from "../Rules/Rules";
import { changeAddress,updateContributionStatus, updateErrorMessage } from "../../../actions";
import { addressDropDownValues } from '../../../../../../../selectors/globalSelectors';


export class AddressDropDownComponent extends React.Component {
    constructor(props) {
        super(props);
        this.onDropdownChange= this.onDropdownChange.bind(this);
        this.state = {
          init:true
        }
        
    }

    componentDidUpdate(nextProps){
      this.reRunValidations(nextProps); 
   }

   


   componentWillReceiveProps(nextProps,nextState){
    let name ='addressdropdownDataID' + this.props.accountId + this.props.contributionType + this.props.assetHeld + this.props.property + this.props.donorId;
    if(this.state.init && this.props.donorId > 0 && this.props.property !== "addressType")
    {
      this.setState({init:this.props.accountSelected != nextProps.accountSelected},()=>{
        let e =  this.getRelationShipData([this.props.value])?.[0]?.value
        this.props.changeAddress(e||this.props.value)
      })     
    }else if(this.props.accountSelected != nextProps.accountSelected)
    {
      this.setState({
        init:true
      })
    }
  
      this.reRunValidations(nextProps);
      if(this.props.donorId && (this.props.assetHeld === nextProps.showErrorMessage.assetHeld) && nextProps.showErrorMessage.dropDown ){
          let id = 'addressdropdownDataID' + this.props.accountId + this.props.contributionType + this.props.assetHeld + this.props.property + this.props.donorId;
          let value = {};
          value[id] =  this.props.value;
          this.props.form.setFieldsValue(value);
        this.props.form.validateFields();
        //bugfix - 6528 - Changes condition based on account selected
        if((this.props.accountId) === this.props.giftLength && (this.props.property === 'relationToDonor' || (this.props.property === 'addressType' && this.props.accountSelected === 'Other donor-advised fund'))){ 
          if(!(['assetHeldatVG','assetOutsideVG'].includes(this.props.assetHeld) && this.props.contributionType === 'mutualFund' && this.props.isSecuritySelected))
            this.props.updateErrorMessages({type: 'dropDown'});
        }
        //bugfix - 6528 - Changes condition based on account selected
        if((this.props.accountId + 1) === this.props.giftLength && (this.props.property === 'relationToDonor' || (this.props.property === 'addressType' && this.props.accountSelected === 'Other donor-advised fund'))){
            if(this.props.accountInfo[this.props.accountId + 1]['type'] === 'Select Account Type'){
              if(!(['assetHeldatVG','assetOutsideVG'].includes(this.props.assetHeld) && this.props.contributionType === 'mutualFund' && this.props.isSecuritySelected)){
                this.props.updateErrorMessages({type: 'dropDown'});
              }
          }
        }
      }
   }

   getRelationShipData = (search,inverse = false)=>{

    return this.props.relationShipData.filter((element)=>{

      return inverse ?!search.includes(element.desc):search.includes(element.desc)

    })

   }

   reRunValidations(nextProps) {
    if(nextProps.value !== this.props.value && this.props.isSameAddress ){
      let id = 'addressdropdownDataID' + this.props.accountId + this.props.contributionType + this.props.assetHeld + this.props.property + this.props.donorId;
      let value = {};
      value[id] =  this.props.value;
      this.props.form.setFieldsValue(value);
      this.props.form.validateFields();
    }
   }

    onDropdownChange = (e) => { 
        if(this.props.donorId > 0) this.props.changeAddress(e);
        this.props.updateContributionStatus();
        let name ='addressdropdownDataID' + this.props.accountId + this.props.contributionType + this.props.assetHeld + this.props.property + this.props.donorId;
        let setfield={}
        setfield[name]=e;
        this.props.form.setFieldsValue(setfield);
        this.props.form.validateFields();
    }

    onDropdownBlur = (e) => {   
      let name='addressdropdownDataID' + this.props.accountId + this.props.contributionType + this.props.assetHeld + this.props.property + this.props.donorId;
      let setfield={}
      setfield[name]=e;
      this.props.form.setFieldsValue(setfield);
      this.props.form.validateFields();

    }


    render() {
        const { getFieldDecorator} = this.props.form;
        const { Option } = Select;
        let dropDownValues = [];
        if(this.props.property === "addressType"){
         dropDownValues = this.props.addressDropDownValues||[];
        }else if(this.props.type === "Corporation" || this.props.type === "Private Foundation"){
            dropDownValues = this.getRelationShipData(["Owner:Organization","Officer:Organization"])

        }else if(this.props.type === "Trust"){
            dropDownValues = this.getRelationShipData(["Trustee:Trust"])
        }else {
          dropDownValues = this.getRelationShipData(["Trustee:Trust","Owner:Organization","Officer:Organization"],true);
        }
        return (

<HideArrow>
<WrapLabel>
  <Form.Item colon={false} label={<LabelWrapper>{this.props.label}</LabelWrapper>}>
  {getFieldDecorator('addressdropdownDataID' + this.props.accountId + this.props.contributionType + this.props.assetHeld + this.props.property + this.props.donorId, {
                        rules:Rules[this.props.property] ? Rules[this.props.property].rules:""
                    })(
      (this.props.donorId === 0) ?
      <InputWrapperGraded>
      <SelectOptionGraded>                
      <InputWrapper >
        <div id={"addressdropdownData" + this.props.accountId + this.props.contributionType + this.props.assetHeld + this.props.property + this.props.donorId} className="relative" data-test='address-drop'>
          <GrantAgreementDropdown onChange={e => this.onDropdownChange(e)}
            aria-labelledby={this.props.property}
            role="list"
            value={this.props.loggedInType} placeholder={"Select the " + this.props.label} disabled
            getPopupContainer={() => document.getElementById("addressdropdownData" + this.props.accountId + this.props.contributionType + this.props.assetHeld + this.props.property + this.props.donorId)}
          >
            {dropDownValues.map((dValue, index) => { return (<Option key={index} value={this.props.property === "addressType"? dValue.desc:dValue.value} ><SelectOptionWrapper>{dValue.desc}</SelectOptionWrapper></Option>) })}
          </GrantAgreementDropdown>
        </div>
      </InputWrapper>
      </SelectOptionGraded>   
      </InputWrapperGraded>
      :
      <InputWrapper>
        <div id={"addressdropdownData" + this.props.accountId + this.props.contributionType + this.props.assetHeld + this.props.property + this.props.donorId} className="relative" data-test='address-dropdown'>
          <GrantAgreementDropdown onChange={e => this.onDropdownChange(e)} onBlur ={e => this.onDropdownBlur(e)}
            aria-labelledby={this.props.property}
            role="list"
            value={this.props.value||undefined}
            placeholder={this.props.placeholder||"Select the " + this.props.label.toLowerCase()}
            getPopupContainer={() => document.getElementById("addressdropdownData" + this.props.accountId + this.props.contributionType + this.props.assetHeld + this.props.property + this.props.donorId)}
          >
            {dropDownValues.map((dValue, index) => { return (<Option key={index} value={this.props.property === "addressType"? dValue.desc:dValue.value} ><SelectOptionWrapper>{dValue.desc}</SelectOptionWrapper></Option>) })}
          </GrantAgreementDropdown>
        </div>
      </InputWrapper>
    )}
  </Form.Item>
</WrapLabel>
</HideArrow>
        )
    }

}

const WrappedAddressDropDownComponent = Form.create({ name: "addressDropdown"})(AddressDropDownComponent);

WrappedAddressDropDownComponent.propTypes = {
  value: PropTypes.string,
  isSameAddress: PropTypes.bool,
  showErrorMessage: PropTypes.object,
  accountInfo: PropTypes.object,
  isDummyUpdated: PropTypes.bool,
  isSecuritySelected: PropTypes.bool,
  loggedInType: PropTypes.string,
  accountSelected: PropTypes.string,
  changeAddress: PropTypes.func,
  updateContributionStatus: PropTypes.func,
  updateErrorMessages: PropTypes.func
}

const mapStateToProps = (state,ownProps) => ({
    value: state.getIn(["makeAContribution", "contributionTypes" , `${ownProps.assetHeld}`, `${ownProps.contributionType}`, `${ownProps.accountId}`, "Donors", `${ownProps.donorId}` ,`${ownProps.property}` ]),
    isSameAddress: state.getIn(["makeAContribution","contributionTypes",`${ownProps.assetHeld}`,`${ownProps.contributionType}`,`${ownProps.accountId}`,"Donors",`${ownProps.donorId}`,'isSameAddress']),
    showErrorMessage: state.getIn(["makeAContribution","contributionTypes",'showErrorMessage']),
    accountInfo: state.getIn(["makeAContribution","contributionTypes",`${ownProps.assetHeld}`, `${ownProps.contributionType}`]),
    isDummyUpdated: state.getIn(["makeAContribution", "contributionTypes", "dummyUpdate"]),
    isSecuritySelected: state.getIn(["makeAContribution","contributionTypes",`${ownProps.assetHeld}`,'sgSelected']),
    loggedInType: state.getIn(['makeAContribution','apiData', 'loggedInAddress','data','addressType']),
    accountSelected: state.getIn(["makeAContribution","contributionTypes",`${ownProps.assetHeld}`,`${ownProps.contributionType}`, `${ownProps.accountId}`,'type']),
    relationShipData:state.getIn(["makeAContribution","apiData","relationShipData"]),
    addressDropDownValues:addressDropDownValues(state.toJS())
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    changeAddress: e => dispatch(changeAddress({value: e, accountId : ownProps.accountId, contributionType: ownProps.contributionType, assetHeld: ownProps.assetHeld, donorId: ownProps.donorId, property: ownProps.property })),
    updateContributionStatus: () => dispatch(updateContributionStatus({value:false,assetHeld: ownProps.assetHeld})),
    updateErrorMessages: data => dispatch(updateErrorMessage(data))
});


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WrappedAddressDropDownComponent));
